export default {
      id: "share-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.125b0740.svg#share",
      toString: function () {
        return this.url;
      }
    }